import { Directive, ElementRef, inject, Input, OnChanges, OnDestroy } from "@angular/core";
import { ComponentProps, createElement, ElementType } from "react";
import { createRoot } from "react-dom/client";


@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[renderReact]',
    standalone: true
})
export class RenderReactDirective<Comp extends ElementType> implements OnChanges, OnDestroy {
    @Input() reactComponent: Comp;
    @Input() props: ComponentProps<Comp> | any;

    // signalProps = input<ComponentProps<Comp>>();

    private root = createRoot(inject(ElementRef).nativeElement)

    ngOnChanges() {
        this.root.render(createElement(this.reactComponent, this.props));
    }

    ngOnDestroy() {
        this.root.unmount();
    }

}
